var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5H4.3625L2.61875 1.9125C2.59835 1.79768 2.53845 1.69361 2.44943 1.61828C2.36041 1.54296 2.24786 1.50112 2.13125 1.5H1",
    stroke: "#737373",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C5.69036 14 6.25 13.4404 6.25 12.75C6.25 12.0596 5.69036 11.5 5 11.5C4.30964 11.5 3.75 12.0596 3.75 12.75C3.75 13.4404 4.30964 14 5 14Z",
    stroke: "#737373",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14C12.1904 14 12.75 13.4404 12.75 12.75C12.75 12.0596 12.1904 11.5 11.5 11.5C10.8096 11.5 10.25 12.0596 10.25 12.75C10.25 13.4404 10.8096 14 11.5 14Z",
    stroke: "#737373",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 9H11.7563C11.99 9.00071 12.2165 8.91902 12.3959 8.76928C12.5754 8.61953 12.6963 8.41133 12.7375 8.18125L13.5 4H3",
    stroke: "#737373",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCart);
export default __webpack_public_path__ + "static/media/PurchaseCart.3dd54cd44496b1cd67e5ac7928faa8eb.svg";
export { ForwardRef as ReactComponent };